export default __webpack_public_path__ + "media/images/clients-04-151x93-193b3bbbf4b3b35a182d1a9e7f2c96c7.png";